import { Controller } from "stimulus";
var onmount = require("onmount");

export default class extends Controller {
  static values = {
    url: String,
    date: String,
  };

  static targets = ["dateLabel", "content", "todayButton"];

  connect() {
    this.activeFilter = "all";
    this.handleAttendanceChanged = this.onAttendanceChanged.bind(this);
    this.element.addEventListener("attendanceChanged", this.handleAttendanceChanged);
    this.loadContent();
  }

  previous() {
    this.dateValue = this.offsetDate(-1);
    this.loadContent();
  }

  next() {
    this.dateValue = this.offsetDate(1);
    this.loadContent();
  }

  filterAll(event) {
    this.activeFilter = "all";
    this.setActiveFilterButton(event.currentTarget);
    this.applyFilter();
  }

  filterAwaitingCheckin(event) {
    this.activeFilter = "awaiting";
    this.setActiveFilterButton(event.currentTarget);
    this.applyFilter();
  }

  filterCheckedin(event) {
    this.activeFilter = "checkedin";
    this.setActiveFilterButton(event.currentTarget);
    this.applyFilter();
  }

  filterCheckedout(event) {
    this.activeFilter = "checkedout";
    this.setActiveFilterButton(event.currentTarget);
    this.applyFilter();
  }

  setActiveFilterButton(activeBtn) {
    $(activeBtn).closest(".btn-group").find(".btn").removeClass("btn-secondary").addClass("btn-light");
    $(activeBtn).removeClass("btn-light").addClass("btn-secondary");
  }

  applyFilter() {
    var filter = this.activeFilter;
    var rows = $(this.contentTarget).find(".js-checkin-checkout-row");

    rows.each(function () {
      var row = $(this);

      if (filter === "all") {
        row.removeClass("d-none");
      } else if (filter === "awaiting") {
        var notCheckedIn = row.find(".js-attendance-icon.not-checked-in-or-out:not(.d-none)").length > 0;
        row.toggleClass("d-none", !notCheckedIn);
      } else if (filter === "checkedin") {
        var checkedIn = row.find(".js-attendance-icon.checked-in:not(.d-none)").length > 0;
        row.toggleClass("d-none", !checkedIn);
      } else if (filter === "checkedout") {
        var checkedOut = row.find(".js-attendance-icon.checked-out:not(.d-none)").length > 0;
        row.toggleClass("d-none", !checkedOut);
      }
    });

    var visibleRows = rows.filter(":not(.d-none)").length;
    var $content = $(this.contentTarget);
    var $emptyState = $content.find(".js-filter-empty-state");

    if (visibleRows === 0 && rows.length > 0) {
      if ($emptyState.length === 0) {
        $content.append('<h5 class="text-light-grey text-center js-filter-empty-state"><i class="fas fa-ban fa-2x"></i></h5>');
      } else {
        $emptyState.removeClass("d-none");
      }
    } else {
      $emptyState.addClass("d-none");
    }
  }

  gotoToday() {
    this.dateValue = new Date().toISOString().split("T")[0];
    this.loadContent();
  }

  pickDate() {
    var controller = this;

    if (this.flatpickrInstance) {
      this.flatpickrInstance.open();
      return;
    }

    this.flatpickrInstance = flatpickr(this.dateLabelTarget, {
      disableMobile: "true",
      defaultDate: this.dateValue,
      onChange: function (selectedDates) {
        if (selectedDates.length === 1) {
          controller.dateValue = selectedDates[0].toISOString().split("T")[0];
          controller.loadContent();
        }
      },
    });

    this.flatpickrInstance.open();
  }

  disconnect() {
    this.element.removeEventListener("attendanceChanged", this.handleAttendanceChanged);
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
      this.flatpickrInstance = null;
    }
  }

  onAttendanceChanged() {
    this.updateFilterCounts();
  }

  loadContent() {
    var controller = this;
    var url = this.urlValue;

    if (url.indexOf("?") !== -1) {
      url = url + "&date=" + this.dateValue;
    } else {
      url = url + "?date=" + this.dateValue;
    }

    this.contentTarget.innerHTML =
      '<div class="text-center"><div class="spinner spinner-border spinner-border-sm text-primary mx-auto my-4"></div></div>';

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (html) {
        controller.contentTarget.innerHTML = html;
        controller.updateDateLabel();
        controller.updateTodayVisibility();
        controller.syncFlatpickr();
        $('[data-toggle="tooltip"]').tooltip({ sanitize: false });
        onmount();
        controller.updateFilterCounts();
        controller.applyFilter();
      },
      error: function () {
        window.notyf.error(
          "Something went wrong when loading your request. Please try again."
        );
      },
    });
  }

  updateDateLabel() {
    var date = new Date(this.dateValue + "T00:00:00");
    var options = { weekday: "short", month: "short", day: "numeric" };
    var formatted = date.toLocaleDateString("en-US", options);
    this.dateLabelTarget.childNodes[0].textContent = formatted;
  }

  updateFilterCounts() {
    var rows = $(this.contentTarget).find(".js-checkin-checkout-row");
    var allCount = rows.length;
    var awaitingCount = 0;
    var checkedInCount = 0;
    var checkedOutCount = 0;

    rows.each(function () {
      var row = $(this);
      if (row.find(".js-attendance-icon.not-checked-in-or-out:not(.d-none)").length > 0) {
        awaitingCount++;
      }
      if (row.find(".js-attendance-icon.checked-in:not(.d-none)").length > 0) {
        checkedInCount++;
      }
      if (row.find(".js-attendance-icon.checked-out:not(.d-none)").length > 0) {
        checkedOutCount++;
      }
    });

    $(this.element).find(".js-all-count").text(" (" + allCount + ")").removeClass("d-none");
    $(this.element).find(".js-awaiting-checkedin-count").text(" (" + awaitingCount + ")").removeClass("d-none");
    $(this.element).find(".js-checkedin-count").text(" (" + checkedInCount + ")").removeClass("d-none");
    $(this.element).find(".js-checkedout-count").text(" (" + checkedOutCount + ")").removeClass("d-none");
  }

  updateTodayVisibility() {
    var today = new Date().toISOString().split("T")[0];
    var isToday = this.dateValue === today;

    if (isToday) {
      $(this.todayButtonTarget).addClass("d-none");
    } else {
      $(this.todayButtonTarget).removeClass("d-none");
    }
  }

  syncFlatpickr() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.setDate(this.dateValue, false);
    }
  }

  offsetDate(days) {
    var date = new Date(this.dateValue + "T00:00:00");
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
  }
}
